/**
 * Affine Dashboard Page
 *
 * Placeholder — the actual iframe is rendered by PersistentAffine in MainLayout.
 * This component exists only to satisfy the router (so /affine is a valid route).
 */

export function AffineDashboardPage() {
  return null;
}
